module.exports = __webpack_public_path__ + "static/media/meet-the-team-4.4ff5ab58.png";